import { render, staticRenderFns } from "./UiValue.vue?vue&type=template&id=9065389e&scoped=true"
import script from "./UiValue.vue?vue&type=script&lang=js"
export * from "./UiValue.vue?vue&type=script&lang=js"
import style0 from "./UiValue.vue?vue&type=style&index=0&id=9065389e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9065389e",
  null
  
)

export default component.exports